import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Address from "../../entity/b2csdu/Address";

const SERVICE = "service-b2csdu";
const ENTITY = "addresses";

export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Address(data);

    return {
        findOneByOrderId(id) {
            return {
                select() {
                    const result = state(state => state.api?.b2csdu?.[ENTITY]?.find(a => a?.getOrderId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec(useCache = true) {
                    findOneBy(SERVICE, ENTITY, "order_id", id, newInstance, "application_v7", false, useCache);
                }
            }
        }
    }
}